import { VdsDropdownItem } from '@volt/volt-extended-components-react';

export interface DropdownItemProps<T> {
  key: string;
  value: T;
  stringValue: string;
  label: string;
}

interface Props<T> {
  items: DropdownItemProps<T>[];
}

export const DropdownItems = <T,>({ items }: Props<T>) => {
  return items.map(({ key, stringValue, label }: DropdownItemProps<T>) => {
    return <VdsDropdownItem key={key} value={stringValue} label={label} size="medium" />;
  });
};

export default DropdownItems;
